import { useMemo } from 'react'

import type { TParametrosRotinaArquivo } from '@/features/simulador/brasil/domain/factories/concrete/horizontal/sacocv/rotina-arquivo-base'
import type { TGetConfiguracoesPrecoResponse } from '@/features/simulador/brasil/http'
import { useParametrosSimulacaoContext } from '@/providers/parametros-simulacao.provider'

export const useParametrosRotinaArquivo = (
  configuracaoDePreco: TGetConfiguracoesPrecoResponse['configuracoesPreco'] | null | undefined,
): TParametrosRotinaArquivo => {
  const parametrosSimulacao = useParametrosSimulacaoContext()
  return useMemo(
    () =>
      ({
        ...configuracaoDePreco?.condicoesDePreco,
        ...configuracaoDePreco?.tabelaDePreco,
        ...parametrosSimulacao,
      }) as TParametrosRotinaArquivo,
    [configuracaoDePreco, parametrosSimulacao],
  )
}
